import { Text, Tooltip } from '$components'
import { ReactNode } from 'react'

export type DescriptionCellProps = {
  children?: ReactNode
}

export function DescriptionCell({ children }: DescriptionCellProps) {

  return (
    <div className="relative z-[2]">
      <Tooltip content={children}>
        <Text
          type="s"
          className="line-clamp-1"
        >
          {children}
        </Text>
      </Tooltip>
    </div>
  )
}
